export default __webpack_public_path__ + "static/Angle_of_View_12mm-Lense-ca21e38a94af9110c715e452ab4d1191.webp";